/* eslint-disable */
;(function(root, factory) {
  if (typeof define === 'function' && define.amd) { // AMD
    define([], factory);
  } else if (typeof exports === 'object') { // Node.js
    module.exports = factory();
  } else { // Browser
    var messages = factory();
    for (var key in messages) {
      root.Blockly.Msg[key] = messages[key];
    }
  }
}(this, function() {
// This file was automatically generated.  Do not modify.

'use strict';

var Blockly = Blockly || { Msg: Object.create(null) };

Blockly.Msg["ADD_COMMENT"] = "Մեկնաբանություն ավելացնել";
Blockly.Msg["ALT_KEY"] = "Alt";  // untranslated
Blockly.Msg["CANNOT_DELETE_VARIABLE_PROCEDURE"] = "Հնարավոր չի ջնջել «%1» փոփոխականը, քանի որ այն «%2» գործառույթի սահմանման մասն է";
Blockly.Msg["CHANGE_VALUE_TITLE"] = "Փոխեք արժեքը՝";
Blockly.Msg["CHROME_OS"] = "ChromeOS";  // untranslated
Blockly.Msg["CLEAN_UP"] = "Մաքրել բլոկները";
Blockly.Msg["CLOSE"] = "Close";  // untranslated
Blockly.Msg["COLLAPSED_WARNINGS_WARNING"] = "Ծալված բլոկները զգուշացումներ են պարունակում։";
Blockly.Msg["COLLAPSE_ALL"] = "Ծալել բլոկները";
Blockly.Msg["COLLAPSE_BLOCK"] = "Ծալել բլոկը";
Blockly.Msg["COLOUR_BLEND_COLOUR1"] = "գույն 1";
Blockly.Msg["COLOUR_BLEND_COLOUR2"] = "գույն 2";
Blockly.Msg["COLOUR_BLEND_HELPURL"] = "https://meyerweb.com/eric/tools/color-blend/#:::rgbp";  // untranslated
Blockly.Msg["COLOUR_BLEND_RATIO"] = "հարաբերակցություն";
Blockly.Msg["COLOUR_BLEND_TITLE"] = "խառնել";
Blockly.Msg["COLOUR_BLEND_TOOLTIP"] = "Խառնում է երկու գույները միմյանց հետ տրված հարաբերակցությամբ (0.0 - 1.0):";
Blockly.Msg["COLOUR_PICKER_HELPURL"] = "https://hy.wikipedia.org/wiki/Գույն";
Blockly.Msg["COLOUR_PICKER_TOOLTIP"] = "Գույն ընտրեք ներկապնակից։";
Blockly.Msg["COLOUR_RANDOM_HELPURL"] = "http://randomcolour.com";  // untranslated
Blockly.Msg["COLOUR_RANDOM_TITLE"] = "պատահական գույն";
Blockly.Msg["COLOUR_RANDOM_TOOLTIP"] = "Գույն է ընտրում պատահականության սկզբունքով։";
Blockly.Msg["COLOUR_RGB_BLUE"] = "կապույտից";
Blockly.Msg["COLOUR_RGB_GREEN"] = "կանաչից";
Blockly.Msg["COLOUR_RGB_HELPURL"] = "https://www.december.com/html/spec/colorpercompact.html";  // untranslated
Blockly.Msg["COLOUR_RGB_RED"] = "կարմրից";
Blockly.Msg["COLOUR_RGB_TITLE"] = "գույն";
Blockly.Msg["COLOUR_RGB_TOOLTIP"] = "Գույն է ստեղծում կարմիրի, կանաչի և կապույտի նշված քանակություններով։ Բոլոր արժեքները պիտի լինեն 0-ի և 100-ի միջև:";
Blockly.Msg["COMMAND_KEY"] = "⌘ Command";  // untranslated
Blockly.Msg["CONTROLS_FLOW_STATEMENTS_HELPURL"] = "https://github.com/google/blockly/wiki/Loops#loop-termination-blocks";  // untranslated
Blockly.Msg["CONTROLS_FLOW_STATEMENTS_OPERATOR_BREAK"] = "դուրս գալ ցիկլից";
Blockly.Msg["CONTROLS_FLOW_STATEMENTS_OPERATOR_CONTINUE"] = "անցնել կրկնության հաջորդ կատարմանը";
Blockly.Msg["CONTROLS_FLOW_STATEMENTS_TOOLTIP_BREAK"] = "Դադարեցնում է տվյալ կրկնությունը";
Blockly.Msg["CONTROLS_FLOW_STATEMENTS_TOOLTIP_CONTINUE"] = "Դադարեցնում կրկնության մնացած մասը և անցնում է հաջորդ քայլին։";
Blockly.Msg["CONTROLS_FLOW_STATEMENTS_WARNING"] = "Զգուշացում. Այս բլոկը կարող է օգտագործվել միայն ցիկլի ներսում:";
Blockly.Msg["CONTROLS_FOREACH_HELPURL"] = "https://github.com/google/blockly/wiki/Loops#for-each";  // untranslated
Blockly.Msg["CONTROLS_FOREACH_TITLE"] = "ամեն մի %1 տարրի համար %2 ցանկից";
Blockly.Msg["CONTROLS_FOREACH_TOOLTIP"] = "Ցանկի յուրաքանչյուր անդամի արժեքը վերագրում է '%1' փոփոխականին և կատարում նշված հրամանները։";
Blockly.Msg["CONTROLS_FOR_HELPURL"] = "https://github.com/google/blockly/wiki/Loops#count-with";  // untranslated
Blockly.Msg["CONTROLS_FOR_TITLE"] = "հաշվել %1-ով %2-ից մինչև %3-ը %4 քայլով";
Blockly.Msg["CONTROLS_FOR_TOOLTIP"] = "«%1» փոփոխականին սահմանված քայլով վերագրում է նախնականից սկսած մինչև վերջնական արժեքը և կատարում է նշված հրամանները։";
Blockly.Msg["CONTROLS_IF_ELSEIF_TOOLTIP"] = "Ավելացնում է պայման «եթե» բլոկին:";
Blockly.Msg["CONTROLS_IF_ELSE_TOOLTIP"] = "Ավելացնել վերջնական ենթաբլոկ (այն կաշխատի, եթե բոլոր պայմանները կեղծ են)";
Blockly.Msg["CONTROLS_IF_HELPURL"] = "https://github.com/google/blockly/wiki/IfElse";  // untranslated
Blockly.Msg["CONTROLS_IF_IF_TOOLTIP"] = "Ավելացնել, հեռացնել կամ փոխել հերթականությունը այս \"եթե\" բլոկը վերակարգավորելու համար։";
Blockly.Msg["CONTROLS_IF_MSG_ELSE"] = "հակառակ դեպքում";
Blockly.Msg["CONTROLS_IF_MSG_ELSEIF"] = "հակառակ դեպքում, եթե";
Blockly.Msg["CONTROLS_IF_MSG_IF"] = "եթե";
Blockly.Msg["CONTROLS_IF_TOOLTIP_1"] = "Եթե պայմանը ճշմարիտ է, կատարում է որոշ հրահանգներ:";
Blockly.Msg["CONTROLS_IF_TOOLTIP_2"] = "Եթե պայմանը ճշմարիտ է, ապա կատարում է հրահանգների առաջին բլոկը: Հակառակ դեպքում կատարում է հրահանգների երկրորդ բլոկը:";
Blockly.Msg["CONTROLS_IF_TOOLTIP_3"] = "Եթե առաջին պայմանը ճշմարիտ է, ապա կատարում է հրահանգների առաջին բլոկը: Հակառակ դեպքում, եթե երկրորդ պայմանն է ճշմարիտ, կատարում է հրահանգների երկրորդ բլոկը:";
Blockly.Msg["CONTROLS_IF_TOOLTIP_4"] = "Եթե առաջին պայմանը ճշմարիտ է, ապա կատարում է հրահանգների առաջին բլոկը: Հակառակ դեպքում, եթե երկրորդ պայմանն է ճշմարիտ, կատարում է հրահանգների երկրորդ բլոկը: Եթե պայմաններից ոչ մեկը ճշմարիտ չեն, ապա կատարում է հրահանգների վերջին բլոկը:";
Blockly.Msg["CONTROLS_REPEAT_HELPURL"] = "https://en.wikipedia.org/wiki/For_loop";  // untranslated
Blockly.Msg["CONTROLS_REPEAT_INPUT_DO"] = "կատարել";
Blockly.Msg["CONTROLS_REPEAT_TITLE"] = "կրկնել %1 անգամ";
Blockly.Msg["CONTROLS_REPEAT_TOOLTIP"] = "Կատարում է որոշ հրահանգներ մի քանի անգամ:";
Blockly.Msg["CONTROLS_WHILEUNTIL_HELPURL"] = "https://github.com/google/blockly/wiki/Loops#repeat";  // untranslated
Blockly.Msg["CONTROLS_WHILEUNTIL_OPERATOR_UNTIL"] = "կրկնել, քանի դեռ չի";
Blockly.Msg["CONTROLS_WHILEUNTIL_OPERATOR_WHILE"] = "կրկնել, քանի դեռ";
Blockly.Msg["CONTROLS_WHILEUNTIL_TOOLTIP_UNTIL"] = "Քանի դեռ արժեքը կեղծ է, կատարում է որոշակի հրահանգներ:";
Blockly.Msg["CONTROLS_WHILEUNTIL_TOOLTIP_WHILE"] = "Քանի դեռ արժեքը ճշմարիտ է, կատարում է հրահանգները:";
Blockly.Msg["CONTROL_KEY"] = "Ctrl";  // untranslated
Blockly.Msg["COPY_SHORTCUT"] = "Copy";  // untranslated
Blockly.Msg["CUT_SHORTCUT"] = "Cut";  // untranslated
Blockly.Msg["DELETE_ALL_BLOCKS"] = "Ջնջե՞լ բոլոր %1 բլոկները։";
Blockly.Msg["DELETE_BLOCK"] = "Ջնջել բլոկը";
Blockly.Msg["DELETE_VARIABLE"] = "Ջնջել «%1» փոփոխականը";
Blockly.Msg["DELETE_VARIABLE_CONFIRMATION"] = "Ջնջե՞լ «%2» փոփոխականի %1 օգտագործումը։";
Blockly.Msg["DELETE_X_BLOCKS"] = "Ջնջել %1 բլոկ";
Blockly.Msg["DIALOG_CANCEL"] = "Չեղարկել";
Blockly.Msg["DIALOG_OK"] = "Լավ";
Blockly.Msg["DISABLE_BLOCK"] = "Անջատել բլոկը";
Blockly.Msg["DUPLICATE_BLOCK"] = "Կրկնօրինակել";
Blockly.Msg["DUPLICATE_COMMENT"] = "Կրկնօրինակել մեկնաբանությունը";
Blockly.Msg["EDIT_BLOCK_CONTENTS"] = "Edit Block contents";  // untranslated
Blockly.Msg["ENABLE_BLOCK"] = "Միացնել բլոկը";
Blockly.Msg["EXPAND_ALL"] = "Ընդարձակել բլոկները";
Blockly.Msg["EXPAND_BLOCK"] = "Ընդարձակել բլոկը";
Blockly.Msg["EXTERNAL_INPUTS"] = "Արտաքին ներածումներ";
Blockly.Msg["HELP"] = "Օգնություն";
Blockly.Msg["HELP_PROMPT"] = "Press %1 for help on keyboard controls";  // untranslated
Blockly.Msg["INLINE_INPUTS"] = "Ներքին ներածումներ";
Blockly.Msg["KEYBOARD_NAV_CONSTRAINED_MOVE_HINT"] = "Use the arrow keys to move, then %1 to accept the position";  // untranslated
Blockly.Msg["KEYBOARD_NAV_COPIED_HINT"] = "Copied. Press %1 to paste.";  // untranslated
Blockly.Msg["KEYBOARD_NAV_CUT_HINT"] = "Cut. Press %1 to paste.";  // untranslated
Blockly.Msg["KEYBOARD_NAV_UNCONSTRAINED_MOVE_HINT"] = "Hold %1 and use arrow keys to move freely, then %2 to accept the position";  // untranslated
Blockly.Msg["LINUX"] = "Linux";  // untranslated
Blockly.Msg["LISTS_CREATE_EMPTY_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#create-empty-list";  // untranslated
Blockly.Msg["LISTS_CREATE_EMPTY_TITLE"] = "ստեղծել դատարկ ցանկ";
Blockly.Msg["LISTS_CREATE_EMPTY_TOOLTIP"] = "Վերադարձնում է 0 երկարությամբ ցանկ, որը տվյալներ չի պարունակում:";
Blockly.Msg["LISTS_CREATE_WITH_CONTAINER_TITLE_ADD"] = "ցանկ";
Blockly.Msg["LISTS_CREATE_WITH_CONTAINER_TOOLTIP"] = "Այս ցանկ բլոկը վերակառուցելու համար ավելացրու, հեռացրու կամ փոխիր բաժինների հաջորդականությունը։";
Blockly.Msg["LISTS_CREATE_WITH_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#create-list-with";  // untranslated
Blockly.Msg["LISTS_CREATE_WITH_INPUT_WITH"] = "ստեղծել ցանկ";
Blockly.Msg["LISTS_CREATE_WITH_ITEM_TOOLTIP"] = "Ավելացնել տարր ցանկին:";
Blockly.Msg["LISTS_CREATE_WITH_TOOLTIP"] = "Ստեղծում է ցանկ ցանկացած քանակությամբ տվյալներով:";
Blockly.Msg["LISTS_GET_INDEX_FIRST"] = "առաջինը";
Blockly.Msg["LISTS_GET_INDEX_FROM_END"] = "№ վերջից";
Blockly.Msg["LISTS_GET_INDEX_FROM_START"] = "№";
Blockly.Msg["LISTS_GET_INDEX_GET"] = "վերցնել";
Blockly.Msg["LISTS_GET_INDEX_GET_REMOVE"] = "վերցնել և հեռացնել";
Blockly.Msg["LISTS_GET_INDEX_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#getting-items-from-a-list";  // untranslated
Blockly.Msg["LISTS_GET_INDEX_LAST"] = "վերջինը";
Blockly.Msg["LISTS_GET_INDEX_RANDOM"] = "պատահական";
Blockly.Msg["LISTS_GET_INDEX_REMOVE"] = "հեռացնել";
Blockly.Msg["LISTS_GET_INDEX_TAIL"] = "";  // untranslated
Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_FIRST"] = "Վերադարձնում է ցանկի առաջին տարրը:";
Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_FROM"] = "Վերադարձնում է նշված դիրքում գտնվող անդամը ցանկից։";
Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_LAST"] = "Վերադարձնում է ցանկի վերջին տարրը:";
Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_RANDOM"] = "Վերադարձնում է ցանկի պատահական տարր:";
Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_FIRST"] = "Հեռացնում և վերադարձնում է ցանկի առաջին տարրը:";
Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_FROM"] = "Հեռացնում և վերադարձնում է նշված դիրքում գտնվող անդամը ցանկից։";
Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_LAST"] = "Հեռացնում և վերադարձնում է ցանկի վերջին տարրը:";
Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_RANDOM"] = "Հեռացնում և վերադարձնում է ցանկի պատահական տարր:";
Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_REMOVE_FIRST"] = "Հեռացնում է ցանկի առաջին տարրը:";
Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_REMOVE_FROM"] = "Ցանկից հեռացնում է նշված դիրքում գտնվող անդամը։";
Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_REMOVE_LAST"] = "Հեռացնում է ցանկի վերջին տարրը:";
Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_REMOVE_RANDOM"] = "Հեռացնում է ցանկից պատահական տարր:";
Blockly.Msg["LISTS_GET_SUBLIST_END_FROM_END"] = "մինչև # վերջից";
Blockly.Msg["LISTS_GET_SUBLIST_END_FROM_START"] = "մինչև #";
Blockly.Msg["LISTS_GET_SUBLIST_END_LAST"] = "մինչև վերջ";
Blockly.Msg["LISTS_GET_SUBLIST_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#getting-a-sublist";  // untranslated
Blockly.Msg["LISTS_GET_SUBLIST_START_FIRST"] = "վերցնել ենթա֊ցանկ սկզբից";
Blockly.Msg["LISTS_GET_SUBLIST_START_FROM_END"] = "վերցնել ենթացանկ, սկսած # վերջից";
Blockly.Msg["LISTS_GET_SUBLIST_START_FROM_START"] = "վերցնել ենթացանկ, սկսած #";
Blockly.Msg["LISTS_GET_SUBLIST_TAIL"] = "";  // untranslated
Blockly.Msg["LISTS_GET_SUBLIST_TOOLTIP"] = "Ստեղծում է ցանկի նշված մասի պատճենը։";
Blockly.Msg["LISTS_INDEX_FROM_END_TOOLTIP"] = "%1 վերջին տարրն է:";
Blockly.Msg["LISTS_INDEX_FROM_START_TOOLTIP"] = "%1 առաջին տարրն է:";
Blockly.Msg["LISTS_INDEX_OF_FIRST"] = "գտնել անդամի առաջին հանդիպման դիրքը";
Blockly.Msg["LISTS_INDEX_OF_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#finding-items-in-a-list";  // untranslated
Blockly.Msg["LISTS_INDEX_OF_LAST"] = "գտնել անդամի վերջին հանդիպման դիրքը";
Blockly.Msg["LISTS_INDEX_OF_TOOLTIP"] = "Վերադարձնում է ցանկում անդամի առաջին/վերջին հանդիպման դիրքը։ Վերադարձնում է %1, եթե անդամը չի գտնվել։";
Blockly.Msg["LISTS_INLIST"] = "ցանկում";
Blockly.Msg["LISTS_ISEMPTY_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#is-empty";  // untranslated
Blockly.Msg["LISTS_ISEMPTY_TITLE"] = "%1 դատարկ է";
Blockly.Msg["LISTS_ISEMPTY_TOOLTIP"] = "Վերադարձնում է \"ճշմարիտ\" եթե ցանկը դատարկ է։";
Blockly.Msg["LISTS_LENGTH_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#length-of";  // untranslated
Blockly.Msg["LISTS_LENGTH_TITLE"] = "%1֊ի երկարությունը";
Blockly.Msg["LISTS_LENGTH_TOOLTIP"] = "Վերադարձնում է ցանկի երկարությունը:";
Blockly.Msg["LISTS_REPEAT_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#create-list-with";  // untranslated
Blockly.Msg["LISTS_REPEAT_TITLE"] = "ստեղծել ցանկ, %1 արժեքը կրկնելով %2 անգամ";
Blockly.Msg["LISTS_REPEAT_TOOLTIP"] = "Տրված արժեքը նշված քանակով կրկնելու միջոցով, ստեղծում է ցանկ։";
Blockly.Msg["LISTS_REVERSE_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#reversing-a-list";  // untranslated
Blockly.Msg["LISTS_REVERSE_MESSAGE0"] = "շրջել %1";
Blockly.Msg["LISTS_REVERSE_TOOLTIP"] = "Շրջում է ցանկի պատճենը։";
Blockly.Msg["LISTS_SET_INDEX_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#in-list--set";  // untranslated
Blockly.Msg["LISTS_SET_INDEX_INPUT_TO"] = "որպես";
Blockly.Msg["LISTS_SET_INDEX_INSERT"] = "ներմուծել";
Blockly.Msg["LISTS_SET_INDEX_SET"] = "դնել";
Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_INSERT_FIRST"] = "Ներմուծում է անդամը ցանկի սկզբում։";
Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_INSERT_FROM"] = "Ներմուծում է անդամը ցանկի նշված դիրքում։";
Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_INSERT_LAST"] = "Ավելացնում է անդամ ցանկի վերջում։";
Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_INSERT_RANDOM"] = "Ներմուծում է անդամը ցանկի պատահական դիրքում։";
Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_SET_FIRST"] = "Սահմանում է ցանկի առաջին տարրը:";
Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_SET_FROM"] = "Տեղադրում է անդամը ցանկի նշված դիրքում։";
Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_SET_LAST"] = "Սահմանում է ցանկի վերջին տարրը:";
Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_SET_RANDOM"] = "Սահմանում է ցանկից պատահական տարր:";
Blockly.Msg["LISTS_SORT_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#sorting-a-list";  // untranslated
Blockly.Msg["LISTS_SORT_ORDER_ASCENDING"] = "աճման կարգ";
Blockly.Msg["LISTS_SORT_ORDER_DESCENDING"] = "նվազման կարգ";
Blockly.Msg["LISTS_SORT_TITLE"] = "դասավորել %1 %2 %3";
Blockly.Msg["LISTS_SORT_TOOLTIP"] = "Դասավորում է ցանկի պատճենը";
Blockly.Msg["LISTS_SORT_TYPE_IGNORECASE"] = "այբենական, անտեսել ռեգիստրը";
Blockly.Msg["LISTS_SORT_TYPE_NUMERIC"] = "թվային կարգ";
Blockly.Msg["LISTS_SORT_TYPE_TEXT"] = "այբբենական կարգ";
Blockly.Msg["LISTS_SPLIT_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#splitting-strings-and-joining-lists";  // untranslated
Blockly.Msg["LISTS_SPLIT_LIST_FROM_TEXT"] = "ստեղծել ցանկ տեքստից";
Blockly.Msg["LISTS_SPLIT_TEXT_FROM_LIST"] = "ստեղծել տեքստ ցանկից";
Blockly.Msg["LISTS_SPLIT_TOOLTIP_JOIN"] = "Ցանկից ստեղծվում է միացյալ տեքստ, ցանկի անդամները միացվում են բաժանարարներով։";
Blockly.Msg["LISTS_SPLIT_TOOLTIP_SPLIT"] = "Տեքստը վեր է ածվում ցանկի, նշված բաժանարարով։";
Blockly.Msg["LISTS_SPLIT_WITH_DELIMITER"] = "բաժանարարով";
Blockly.Msg["LOGIC_BOOLEAN_FALSE"] = "կեղծ";
Blockly.Msg["LOGIC_BOOLEAN_HELPURL"] = "https://github.com/google/blockly/wiki/Logic#values";  // untranslated
Blockly.Msg["LOGIC_BOOLEAN_TOOLTIP"] = "Վերադարձնում է ճշմարիտ կամ կեղծ արժեք:";
Blockly.Msg["LOGIC_BOOLEAN_TRUE"] = "ճշմարիտ";
Blockly.Msg["LOGIC_COMPARE_HELPURL"] = "https://hy.wikipedia.org/wiki/Անհավասարություն";
Blockly.Msg["LOGIC_COMPARE_TOOLTIP_EQ"] = "Վերադարձնում է ճշմարիտ արժեք, եթե երկու մուտքերն էլ հավասար են միմյանց:";
Blockly.Msg["LOGIC_COMPARE_TOOLTIP_GT"] = "Վերադարձնում է ճշմարիտ արժեք, եթե առաջին մուտքը մեծ է երկրորդից:";
Blockly.Msg["LOGIC_COMPARE_TOOLTIP_GTE"] = "Վերադարձնում է ճշմարիտ արժեք, եթե առաջին մուտքը մեծ կամ հավասար է երկրորդին:";
Blockly.Msg["LOGIC_COMPARE_TOOLTIP_LT"] = "Վերադարձնում է ճշմարիտ արժեք, եթե մուտքերից առաջինը փոքր է երկրորդից:";
Blockly.Msg["LOGIC_COMPARE_TOOLTIP_LTE"] = "Վերադարձնում է ճշմարիտ արժեք, եթե առաջին մուտքը փոքր կամ հավասար է երկրորդին:";
Blockly.Msg["LOGIC_COMPARE_TOOLTIP_NEQ"] = "Վերադարձնում է ճշմարիտ արժեք, եթե երկու մուտքերն էլ հավասար չեն միմյանց:";
Blockly.Msg["LOGIC_NEGATE_HELPURL"] = "https://github.com/google/blockly/wiki/Logic#not";  // untranslated
Blockly.Msg["LOGIC_NEGATE_TITLE"] = "ոչ %1";
Blockly.Msg["LOGIC_NEGATE_TOOLTIP"] = "Վերադարձնում է ճշմարիտ արժեք, եթե մուտքը կեղծ է: Վերադարձնում է կեղծ արժեք, եթե մուտքը ճշմարիտ է:";
Blockly.Msg["LOGIC_NULL"] = "ոչինչ";
Blockly.Msg["LOGIC_NULL_HELPURL"] = "https://en.wikipedia.org/wiki/Nullable_type";  // untranslated
Blockly.Msg["LOGIC_NULL_TOOLTIP"] = "Վերադարձնում է null (ոչինչ)";
Blockly.Msg["LOGIC_OPERATION_AND"] = "և";
Blockly.Msg["LOGIC_OPERATION_HELPURL"] = "https://github.com/google/blockly/wiki/Logic#logical-operations";  // untranslated
Blockly.Msg["LOGIC_OPERATION_OR"] = "կամ";
Blockly.Msg["LOGIC_OPERATION_TOOLTIP_AND"] = "Վերադարձնում է ճշմարիտ արժեք, եթե երկու մուտքերն էլ ճշմարիտ են:";
Blockly.Msg["LOGIC_OPERATION_TOOLTIP_OR"] = "Վերադարձնում է ճշմարիտ արժեք, եթե մուտքերից գոնե մեկը ճշմարիտ է:";
Blockly.Msg["LOGIC_TERNARY_CONDITION"] = "ստուգում";
Blockly.Msg["LOGIC_TERNARY_HELPURL"] = "https://en.wikipedia.org/wiki/%3F:";  // untranslated
Blockly.Msg["LOGIC_TERNARY_IF_FALSE"] = "եթե կեղծ է";
Blockly.Msg["LOGIC_TERNARY_IF_TRUE"] = "եթե ճշմարիտ է";
Blockly.Msg["LOGIC_TERNARY_TOOLTIP"] = "Ստուգում է ընտրության պայմանը։ Եթե այն ճշմարիտ է, վերադարձնում է առաջին արժեքը, հակառակ դեպքում ՝ երկրորդը։";
Blockly.Msg["MAC_OS"] = "macOS";  // untranslated
Blockly.Msg["MATH_ADDITION_SYMBOL"] = "+";  // untranslated
Blockly.Msg["MATH_ARITHMETIC_HELPURL"] = "https://hy.wikipedia.org/wiki/Թվաբանություն";
Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_ADD"] = "Վերադարձնում է երկու թվերի գումարը:";
Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_DIVIDE"] = "Վերադարձնում է քանորդը";
Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_MINUS"] = "Վերադարձնում է երկու թվերի տարբերությունը:";
Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_MULTIPLY"] = "Վերադարձնում է երկու թվերի արտադրյալը";
Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_POWER"] = "Վերադարձնում է առաջին թիվի աստիճանը";
Blockly.Msg["MATH_ATAN2_HELPURL"] = "https://en.wikipedia.org/wiki/Atan2";  // untranslated
Blockly.Msg["MATH_ATAN2_TITLE"] = "X:%1 Y:%2 ֊ի atan2֊ը";
Blockly.Msg["MATH_ATAN2_TOOLTIP"] = "Վերադարձնում է (X, Y) կետի արկտանգենսը աստիճաններով -180-ից մինչև 180:";
Blockly.Msg["MATH_CHANGE_HELPURL"] = "https://en.wikipedia.org/wiki/Programming_idiom#Incrementing_a_counter";  // untranslated
Blockly.Msg["MATH_CHANGE_TITLE"] = "փոխել %1-ի արժեքը %2֊ով";
Blockly.Msg["MATH_CHANGE_TOOLTIP"] = "Ավելացնում է թիվ %1 փոփոխականին:";
Blockly.Msg["MATH_CONSTANT_HELPURL"] = "https://hy.wikipedia.org/wiki/Մաթեմատիկական_հաստատուն";
Blockly.Msg["MATH_CONSTANT_TOOLTIP"] = "Վերադարձնում է տարածված հաստատուններից մեկը՝ π (3.141…), e (2.718…), φ (1.618…), sqrt(2) (1.414…), sqrt(½) (0.707…), կամ ∞ (անվերջություն):";
Blockly.Msg["MATH_CONSTRAIN_HELPURL"] = "https://en.wikipedia.org/wiki/Clamping_(graphics)";  // untranslated
Blockly.Msg["MATH_CONSTRAIN_TITLE"] = "սահմանափակել %1֊ը %2֊ի և %3֊ի միջև";
Blockly.Msg["MATH_CONSTRAIN_TOOLTIP"] = "Սահմանափակել թիվը երկու արժեքներով (ներառյալ)";
Blockly.Msg["MATH_DIVISION_SYMBOL"] = "÷";  // untranslated
Blockly.Msg["MATH_IS_DIVISIBLE_BY"] = "բաժանվում է";
Blockly.Msg["MATH_IS_EVEN"] = "զույգ է";
Blockly.Msg["MATH_IS_NEGATIVE"] = "բացասական է";
Blockly.Msg["MATH_IS_ODD"] = "կենտ է";
Blockly.Msg["MATH_IS_POSITIVE"] = "դրական է";
Blockly.Msg["MATH_IS_PRIME"] = "պարզ է";
Blockly.Msg["MATH_IS_TOOLTIP"] = "Ստուգում է, թե թիվը զույգ է, կենտ է, պարզ է, ամբողջ է, դրական է, բացասական է կամ թե այն բաժանվում է որոշակի թվի վրա: Վերադարձնում է ճշմարիտ կամ կեղծ:";
Blockly.Msg["MATH_IS_WHOLE"] = "ամբողջ է";
Blockly.Msg["MATH_MODULO_HELPURL"] = "https://en.wikipedia.org/wiki/Modulo_operation";  // untranslated
Blockly.Msg["MATH_MODULO_TITLE"] = "%1֊ի և %2֊ի բաժանման մնացորդը";
Blockly.Msg["MATH_MODULO_TOOLTIP"] = "Վերադարձնում է երկու թվերի բաժանման մնացորդը:";
Blockly.Msg["MATH_MULTIPLICATION_SYMBOL"] = "×";  // untranslated
Blockly.Msg["MATH_NUMBER_HELPURL"] = "https://hy.wikipedia.org/wiki/Թիվ";
Blockly.Msg["MATH_NUMBER_TOOLTIP"] = "Թիվ";
Blockly.Msg["MATH_ONLIST_HELPURL"] = "";  // untranslated
Blockly.Msg["MATH_ONLIST_OPERATOR_AVERAGE"] = "ցանկի միջինը";
Blockly.Msg["MATH_ONLIST_OPERATOR_MAX"] = "ցանկի առավելագույնը";
Blockly.Msg["MATH_ONLIST_OPERATOR_MEDIAN"] = "ցանկի միջնարժեք";
Blockly.Msg["MATH_ONLIST_OPERATOR_MIN"] = "ցանկի նվազագույնը";
Blockly.Msg["MATH_ONLIST_OPERATOR_MODE"] = "ցանկի մոդան";
Blockly.Msg["MATH_ONLIST_OPERATOR_RANDOM"] = "ցանկի պատահական տարր";
Blockly.Msg["MATH_ONLIST_OPERATOR_STD_DEV"] = "ցանկի ստանդարտ շեղում";
Blockly.Msg["MATH_ONLIST_OPERATOR_SUM"] = "ցանկի գումարը";
Blockly.Msg["MATH_ONLIST_TOOLTIP_AVERAGE"] = "Վերադարձնում է ցանկում գտնվող արժեքների թվաբանական միջինը";
Blockly.Msg["MATH_ONLIST_TOOLTIP_MAX"] = "Վերադարձնում է ցանկի արժեքներից առավելագույնը";
Blockly.Msg["MATH_ONLIST_TOOLTIP_MEDIAN"] = "Վերադարձնում է ցանկի միջնարժեք:";
Blockly.Msg["MATH_ONLIST_TOOLTIP_MIN"] = "Վերադարձնում է ցանկի արժեքներից նվազագույնը";
Blockly.Msg["MATH_ONLIST_TOOLTIP_MODE"] = "Վերադարձնում է ցանկի առավել հաճախ հանդիպող անդամների ցանկը։";
Blockly.Msg["MATH_ONLIST_TOOLTIP_RANDOM"] = "Վերադարձնում է պատահական տարր ցանկից:";
Blockly.Msg["MATH_ONLIST_TOOLTIP_STD_DEV"] = "Վերադարձնում է ցանկի ստանդարտ շեղումը:";
Blockly.Msg["MATH_ONLIST_TOOLTIP_SUM"] = "Վերադարձնում է ցանկի բոլոր թվերի գումարը:";
Blockly.Msg["MATH_POWER_SYMBOL"] = "^";  // untranslated
Blockly.Msg["MATH_RANDOM_FLOAT_HELPURL"] = "https://en.wikipedia.org/wiki/Պատահական_թվերի_գեներատոր";
Blockly.Msg["MATH_RANDOM_FLOAT_TITLE_RANDOM"] = "պատահական կոտորակ";
Blockly.Msg["MATH_RANDOM_FLOAT_TOOLTIP"] = "Վերադարձնում է պատահական թիվ 0.0-ից (ներառյալ) 1.0 միջակայքից:";
Blockly.Msg["MATH_RANDOM_INT_HELPURL"] = "https://en.wikipedia.org/wiki/Random_number_generation";  // untranslated
Blockly.Msg["MATH_RANDOM_INT_TITLE"] = "պատահական ամբողջ թիվ %1 -ից %2 -ը";
Blockly.Msg["MATH_RANDOM_INT_TOOLTIP"] = "Վերադարձնում է պատահական ամբողջ թիվ տրված երկու թվերի միջև (ներառյալ):";
Blockly.Msg["MATH_ROUND_HELPURL"] = "https://en.wikipedia.org/wiki/Կլորացում";
Blockly.Msg["MATH_ROUND_OPERATOR_ROUND"] = "կլորացնել";
Blockly.Msg["MATH_ROUND_OPERATOR_ROUNDDOWN"] = "կլորացնել ցած";
Blockly.Msg["MATH_ROUND_OPERATOR_ROUNDUP"] = "կլորացնել վեր";
Blockly.Msg["MATH_ROUND_TOOLTIP"] = "Կլորացնում է թիվը վերև կամ ներքև:";
Blockly.Msg["MATH_SINGLE_HELPURL"] = "https://en.wikipedia.org/wiki/Square_root";  // untranslated
Blockly.Msg["MATH_SINGLE_OP_ABSOLUTE"] = "բացարձակ";
Blockly.Msg["MATH_SINGLE_OP_ROOT"] = "Քառակուսի արմատ";
Blockly.Msg["MATH_SINGLE_TOOLTIP_ABS"] = "Վերադարձնում է թվի բացարձակ արժեքը:";
Blockly.Msg["MATH_SINGLE_TOOLTIP_EXP"] = "Վերադարձնում է թվի աստիճանը։";
Blockly.Msg["MATH_SINGLE_TOOLTIP_LN"] = "Վերադարձնում է թվի բնական լոգարիթմը:";
Blockly.Msg["MATH_SINGLE_TOOLTIP_LOG10"] = "Վերադարձնում է թվի 10 հիմքով լոգարիթմը:";
Blockly.Msg["MATH_SINGLE_TOOLTIP_NEG"] = "Վերադարձնում է ժխտված թիվը:";
Blockly.Msg["MATH_SINGLE_TOOLTIP_POW10"] = "Վերադարձնում է 10֊ի նշված աստիճանը։";
Blockly.Msg["MATH_SINGLE_TOOLTIP_ROOT"] = "Վերադարձնում է թվի քառակուսի աստիճանը";
Blockly.Msg["MATH_SUBTRACTION_SYMBOL"] = "-";  // untranslated
Blockly.Msg["MATH_TRIG_ACOS"] = "arccos";
Blockly.Msg["MATH_TRIG_ASIN"] = "arcsin";
Blockly.Msg["MATH_TRIG_ATAN"] = "arctan";
Blockly.Msg["MATH_TRIG_COS"] = "cos";
Blockly.Msg["MATH_TRIG_HELPURL"] = "https://hy.wikipedia.org/wiki/Եռանկյունաչափական_ֆունկցիաներ";
Blockly.Msg["MATH_TRIG_SIN"] = "sin";
Blockly.Msg["MATH_TRIG_TAN"] = "tan";
Blockly.Msg["MATH_TRIG_TOOLTIP_ACOS"] = "Վերադարձնում է թվի արկկոսինուսը:";
Blockly.Msg["MATH_TRIG_TOOLTIP_ASIN"] = "Վերադարձնում է թվի արկսինուսը(աստիճաններով):";
Blockly.Msg["MATH_TRIG_TOOLTIP_ATAN"] = "Վերադարձնում է թվի արկտանգենսը:";
Blockly.Msg["MATH_TRIG_TOOLTIP_COS"] = "Վերադարձնում է անկյան կոսինուսը աստիճաններով (ոչ ռադիաններով):";
Blockly.Msg["MATH_TRIG_TOOLTIP_SIN"] = "Վերադարձնում է անկյան սինուսը աստիճաններով(ոչ ռադիաններով):";
Blockly.Msg["MATH_TRIG_TOOLTIP_TAN"] = "Վերադարձնում է անկյան տանգենսը աստիճաններով (ոչ ռադիաններով):";
Blockly.Msg["MOVE_BLOCK"] = "Move Block";  // untranslated
Blockly.Msg["NEW_COLOUR_VARIABLE"] = "Գույնի փոփոխական ստեղծել...";
Blockly.Msg["NEW_NUMBER_VARIABLE"] = "Թվային փոփոխական ստեղծել...";
Blockly.Msg["NEW_STRING_VARIABLE"] = "Տողային փոփոխական ստեղծել...";
Blockly.Msg["NEW_VARIABLE"] = "Ստեղծել փոփոխական...";
Blockly.Msg["NEW_VARIABLE_TITLE"] = "Նոր փոփոխականի անունը՝";
Blockly.Msg["NEW_VARIABLE_TYPE_TITLE"] = "Փոփոխականի նոր տեսակ՝";
Blockly.Msg["OPTION_KEY"] = "⌥ Option";  // untranslated
Blockly.Msg["ORDINAL_NUMBER_SUFFIX"] = "";  // untranslated
Blockly.Msg["PASTE_SHORTCUT"] = "Paste";  // untranslated
Blockly.Msg["PROCEDURES_ALLOW_STATEMENTS"] = "թույլատրել արտահայտությունները";
Blockly.Msg["PROCEDURES_BEFORE_PARAMS"] = "պարամետրերի ցանկ՝";
Blockly.Msg["PROCEDURES_CALLNORETURN_HELPURL"] = "https://en.wikipedia.org/wiki/Subroutine";  // untranslated
Blockly.Msg["PROCEDURES_CALLNORETURN_TOOLTIP"] = "Կատարում է %1 ֆունկցիան";
Blockly.Msg["PROCEDURES_CALLRETURN_HELPURL"] = "https://en.wikipedia.org/wiki/Subroutine";  // untranslated
Blockly.Msg["PROCEDURES_CALLRETURN_TOOLTIP"] = "Կատարում է '%1' ֆունկցիան և օգտագործում դրա արդյունքը։";
Blockly.Msg["PROCEDURES_CALL_BEFORE_PARAMS"] = "պարամետրերի ցանկ՝";
Blockly.Msg["PROCEDURES_CALL_DISABLED_DEF_WARNING"] = "Can't run the user-defined function '%1' because the definition block is disabled.";  // untranslated
Blockly.Msg["PROCEDURES_CREATE_DO"] = "Ստեղծել '%1'";
Blockly.Msg["PROCEDURES_DEFNORETURN_COMMENT"] = "Նկարագրեք այս գործառույթը...";
Blockly.Msg["PROCEDURES_DEFNORETURN_DO"] = "";  // untranslated
Blockly.Msg["PROCEDURES_DEFNORETURN_HELPURL"] = "https://en.wikipedia.org/wiki/Subroutine";  // untranslated
Blockly.Msg["PROCEDURES_DEFNORETURN_PROCEDURE"] = "կատարել որևէ բան";
Blockly.Msg["PROCEDURES_DEFNORETURN_TITLE"] = "ֆունկցիա";
Blockly.Msg["PROCEDURES_DEFNORETURN_TOOLTIP"] = "Ստեղծում է ֆունկցիա, որը արժեք չի վերադարձնում:";
Blockly.Msg["PROCEDURES_DEFRETURN_HELPURL"] = "https://en.wikipedia.org/wiki/Subroutine";  // untranslated
Blockly.Msg["PROCEDURES_DEFRETURN_RETURN"] = "վերադարձնել";
Blockly.Msg["PROCEDURES_DEFRETURN_TOOLTIP"] = "Ստեղծում է ֆունկցիա, որը վերադարձնում է արժեք:";
Blockly.Msg["PROCEDURES_DEF_DUPLICATE_WARNING"] = "Զգուշացում։ Այս ֆունկցիան ունի կրկնվող պարամտերեր։";
Blockly.Msg["PROCEDURES_HIGHLIGHT_DEF"] = "Ընդգծել ֆունկցիայի հայտարարումը";
Blockly.Msg["PROCEDURES_IFRETURN_HELPURL"] = "https://c2.com/cgi/wiki?GuardClause";  // untranslated
Blockly.Msg["PROCEDURES_IFRETURN_TOOLTIP"] = "Եթե արժեքը ճշմարիտ է, վերադարձնում է երկորդ արժեքը:";
Blockly.Msg["PROCEDURES_IFRETURN_WARNING"] = "Զգուշացում. Այս բլոկը կարող է օգտագործվել միայն ֆունկցիայի սահմանման ներսում:";
Blockly.Msg["PROCEDURES_MUTATORARG_TITLE"] = "մուտքի անուն՝";
Blockly.Msg["PROCEDURES_MUTATORARG_TOOLTIP"] = "Ֆունկցիային ավելալցնել մուտք (պարամետր)։";
Blockly.Msg["PROCEDURES_MUTATORCONTAINER_TITLE"] = "մուտքեր";
Blockly.Msg["PROCEDURES_MUTATORCONTAINER_TOOLTIP"] = "Ավելացնել, հեռացնել կամ վերադասավորել է այս ֆունկցիայի մուտքերը (պարամետրերը)։";
Blockly.Msg["REDO"] = "Կրկնել";
Blockly.Msg["REMOVE_COMMENT"] = "Հեռացնել մեկնաբանությունը";
Blockly.Msg["RENAME_VARIABLE"] = "Վերանվանել փոփոխականը...";
Blockly.Msg["RENAME_VARIABLE_TITLE"] = "Բոլոր «%1» փոփոխականները վերանվանել՝";
Blockly.Msg["SHORTCUTS_CODE_NAVIGATION"] = "Code navigation";  // untranslated
Blockly.Msg["SHORTCUTS_EDITING"] = "Editing";  // untranslated
Blockly.Msg["SHORTCUTS_GENERAL"] = "General";  // untranslated
Blockly.Msg["TEXT_APPEND_HELPURL"] = "https://github.com/google/blockly/wiki/Text#text-modification";  // untranslated
Blockly.Msg["TEXT_APPEND_TITLE"] = "%1֊ին կցել %2 տեքստը";
Blockly.Msg["TEXT_APPEND_TOOLTIP"] = "Կցել տեքստ '%1' փոփոխականին";
Blockly.Msg["TEXT_CHANGECASE_HELPURL"] = "https://github.com/google/blockly/wiki/Text#adjusting-text-case";  // untranslated
Blockly.Msg["TEXT_CHANGECASE_OPERATOR_LOWERCASE"] = "բերել փոքրատառերի";
Blockly.Msg["TEXT_CHANGECASE_OPERATOR_TITLECASE"] = "բերել Սկզբնա Մեծատառերի";
Blockly.Msg["TEXT_CHANGECASE_OPERATOR_UPPERCASE"] = "բերել ՄԵԾԱՏԱՌԵՐԻ";
Blockly.Msg["TEXT_CHANGECASE_TOOLTIP"] = "Վերադարձնում է տեքստի կրկնօրինակը, ՄԵԾԱՏԱՌԵՐՈՎ կամ փոքրատառերով";
Blockly.Msg["TEXT_CHARAT_FIRST"] = "վերցնել առաջին տառը";
Blockly.Msg["TEXT_CHARAT_FROM_END"] = "վերցնել տառ № վերջից";
Blockly.Msg["TEXT_CHARAT_FROM_START"] = "վերցնել տառ №";
Blockly.Msg["TEXT_CHARAT_HELPURL"] = "https://github.com/google/blockly/wiki/Text#extracting-text";  // untranslated
Blockly.Msg["TEXT_CHARAT_LAST"] = "վերցնել վերջին տառը";
Blockly.Msg["TEXT_CHARAT_RANDOM"] = "վերցնել պատահական տառ";
Blockly.Msg["TEXT_CHARAT_TAIL"] = "";  // untranslated
Blockly.Msg["TEXT_CHARAT_TITLE"] = "տեքստում %1 %2";
Blockly.Msg["TEXT_CHARAT_TOOLTIP"] = "Վերադարձնում է նշված դիրքի տառը";
Blockly.Msg["TEXT_COUNT_HELPURL"] = "https://github.com/google/blockly/wiki/Text#counting-substrings";  // untranslated
Blockly.Msg["TEXT_COUNT_MESSAGE0"] = "հաշվել %1 %2֊ում";
Blockly.Msg["TEXT_COUNT_TOOLTIP"] = "Հաշվել, թե քանի անգամ է տեքստը հանդիպում մեկ այլ տեքստի մեջ։";
Blockly.Msg["TEXT_CREATE_JOIN_ITEM_TOOLTIP"] = "Ավելացնել էլեմենտ տեքստին:";
Blockly.Msg["TEXT_CREATE_JOIN_TITLE_JOIN"] = "կցել";
Blockly.Msg["TEXT_CREATE_JOIN_TOOLTIP"] = "Այս տեքստային բլոկը վերակառուցելու համար ավելացրու, հեռացրու կամ փոխիր բաժինների հերթականությունը";
Blockly.Msg["TEXT_GET_SUBSTRING_END_FROM_END"] = "մինչև # տառը, վերջից";
Blockly.Msg["TEXT_GET_SUBSTRING_END_FROM_START"] = "մինչև # տառը";
Blockly.Msg["TEXT_GET_SUBSTRING_END_LAST"] = "մինչև վերջին տառը";
Blockly.Msg["TEXT_GET_SUBSTRING_HELPURL"] = "https://github.com/google/blockly/wiki/Text#extracting-a-region-of-text";  // untranslated
Blockly.Msg["TEXT_GET_SUBSTRING_INPUT_IN_TEXT"] = "տեքստում";
Blockly.Msg["TEXT_GET_SUBSTRING_START_FIRST"] = "տալիս է ենթատող առաջին տառից";
Blockly.Msg["TEXT_GET_SUBSTRING_START_FROM_END"] = "տալիս է ենթատող # տառից սկսած, վերջից";
Blockly.Msg["TEXT_GET_SUBSTRING_START_FROM_START"] = "տալիս է ենթատող սկսելով # տառից";
Blockly.Msg["TEXT_GET_SUBSTRING_TAIL"] = "";  // untranslated
Blockly.Msg["TEXT_GET_SUBSTRING_TOOLTIP"] = "Վերադարձնում է տեքստի նշված մասը։";
Blockly.Msg["TEXT_INDEXOF_HELPURL"] = "https://github.com/google/blockly/wiki/Text#finding-text";  // untranslated
Blockly.Msg["TEXT_INDEXOF_OPERATOR_FIRST"] = "գտնել տեքստի առաջին հանդիպումը";
Blockly.Msg["TEXT_INDEXOF_OPERATOR_LAST"] = "գտնել տեքստի վերջին հանդիպումը";
Blockly.Msg["TEXT_INDEXOF_TITLE"] = "Տեքստում %1 %2 %3";
Blockly.Msg["TEXT_INDEXOF_TOOLTIP"] = "Վերադարձնում է առաջին տեքստի հանդիպման առաջին (կամ վերջին) դիրքը երկրորդ տեքստում։ Վերադարձնում է %1, եթե տեքստը չի գտնվել։";
Blockly.Msg["TEXT_ISEMPTY_HELPURL"] = "https://github.com/google/blockly/wiki/Text#checking-for-empty-text";  // untranslated
Blockly.Msg["TEXT_ISEMPTY_TITLE"] = "%1 -ը դատարկ է";
Blockly.Msg["TEXT_ISEMPTY_TOOLTIP"] = "Վերադարձնում է ճշմարիտ արժեք, եթե տրամադրված տեքստը դատարկ է:";
Blockly.Msg["TEXT_JOIN_HELPURL"] = "https://github.com/google/blockly/wiki/Text#text-creation";  // untranslated
Blockly.Msg["TEXT_JOIN_TITLE_CREATEWITH"] = "ստեղծել տեքստ";
Blockly.Msg["TEXT_JOIN_TOOLTIP"] = "Ստեղծում է տեքստի մաս՝ միմյանց կցելով ցանկացած քանակությամբ տարրեր:";
Blockly.Msg["TEXT_LENGTH_HELPURL"] = "https://github.com/google/blockly/wiki/Text#text-modification";  // untranslated
Blockly.Msg["TEXT_LENGTH_TITLE"] = "%1 -ի երկարությունը";
Blockly.Msg["TEXT_LENGTH_TOOLTIP"] = "Վերադարձնում է տրված տեքստի տառերի քանակը (ներառյալ բացատները)";
Blockly.Msg["TEXT_PRINT_HELPURL"] = "https://github.com/google/blockly/wiki/Text#printing-text";  // untranslated
Blockly.Msg["TEXT_PRINT_TITLE"] = "տպել %1";
Blockly.Msg["TEXT_PRINT_TOOLTIP"] = "Տպում է նշված տեքստը, թիվը կամ այլ արժեք․";
Blockly.Msg["TEXT_PROMPT_HELPURL"] = "https://github.com/google/blockly/wiki/Text#getting-input-from-the-user";  // untranslated
Blockly.Msg["TEXT_PROMPT_TOOLTIP_NUMBER"] = "Հարցնել թիվ օգտատիրոջից։";
Blockly.Msg["TEXT_PROMPT_TOOLTIP_TEXT"] = "Հարցնել տեքստ օգտատիրոջից։";
Blockly.Msg["TEXT_PROMPT_TYPE_NUMBER"] = "հացնել թիվ, հուշումով";
Blockly.Msg["TEXT_PROMPT_TYPE_TEXT"] = "հարցնել տեքստ, հուշումով";
Blockly.Msg["TEXT_REPLACE_HELPURL"] = "https://github.com/google/blockly/wiki/Text#replacing-substrings";  // untranslated
Blockly.Msg["TEXT_REPLACE_MESSAGE0"] = "փոխարինել %1֊ը %2֊ով %3֊ում";
Blockly.Msg["TEXT_REPLACE_TOOLTIP"] = "Փոխարինել տեքստի բոլոր գտնված տարբերակները մեկ այլ տեսքով։";
Blockly.Msg["TEXT_REVERSE_HELPURL"] = "https://github.com/google/blockly/wiki/Text#reversing-text";  // untranslated
Blockly.Msg["TEXT_REVERSE_MESSAGE0"] = "շրջել %1";
Blockly.Msg["TEXT_REVERSE_TOOLTIP"] = "Փոխում է տեքստում տառերի հաջորդականությունը։";
Blockly.Msg["TEXT_TEXT_HELPURL"] = "https://en.wikipedia.org/wiki/String_(computer_science)";  // untranslated
Blockly.Msg["TEXT_TEXT_TOOLTIP"] = "Տառ, բառ կամ տեքստի տող:";
Blockly.Msg["TEXT_TRIM_HELPURL"] = "https://github.com/google/blockly/wiki/Text#trimming-removing-spaces";  // untranslated
Blockly.Msg["TEXT_TRIM_OPERATOR_BOTH"] = "կտրում է բացատները երկու կողմերից";
Blockly.Msg["TEXT_TRIM_OPERATOR_LEFT"] = "կտրում է բացատները ձախ կողմից";
Blockly.Msg["TEXT_TRIM_OPERATOR_RIGHT"] = "կտրում է բացատները աջ կողմից";
Blockly.Msg["TEXT_TRIM_TOOLTIP"] = "Վերադարձնում է տեքստի կրկնօրինակը, առանց սկզբի կամ/և վերջի բացատների։";
Blockly.Msg["TODAY"] = "Այսօր";
Blockly.Msg["UNDO"] = "Հետարկել";
Blockly.Msg["UNKNOWN"] = "Unknown";  // untranslated
Blockly.Msg["UNNAMED_KEY"] = "առանց անվանման";
Blockly.Msg["VARIABLES_DEFAULT_NAME"] = "տարր";
Blockly.Msg["VARIABLES_GET_CREATE_SET"] = "Ստեղծել 'վերագրել %1'";
Blockly.Msg["VARIABLES_GET_HELPURL"] = "https://github.com/google/blockly/wiki/Variables#get";  // untranslated
Blockly.Msg["VARIABLES_GET_TOOLTIP"] = "Վերադարձնում է այս փոփոխականի արժեքը:";
Blockly.Msg["VARIABLES_SET"] = "վերագրել %1֊ին %2 արժեքը";
Blockly.Msg["VARIABLES_SET_CREATE_GET"] = "ստեղծել 'ստանալ %1'";
Blockly.Msg["VARIABLES_SET_HELPURL"] = "https://github.com/google/blockly/wiki/Variables#set";  // untranslated
Blockly.Msg["VARIABLES_SET_TOOLTIP"] = "Փոփոխականին վերագրում է ներմուծված արժեքը։";
Blockly.Msg["VARIABLE_ALREADY_EXISTS"] = "«%1» անունով փոփոխական արդեն գոյություն ունի։";
Blockly.Msg["VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE"] = "«%1» անունով փոփոխական արդեն գոյություն ունի մեկ այլ տեսակի համար՝ «%2»։";
Blockly.Msg["VARIABLE_ALREADY_EXISTS_FOR_A_PARAMETER"] = "A variable named '%1' already exists as a parameter in the procedure '%2'.";  // untranslated
Blockly.Msg["WINDOWS"] = "Windows";  // untranslated
Blockly.Msg["WORKSPACE_ARIA_LABEL"] = "Blockly աշխատատարածք";
Blockly.Msg["WORKSPACE_COMMENT_DEFAULT_TEXT"] = "Մի բան ասա ․․․";
Blockly.Msg["CONTROLS_FOREACH_INPUT_DO"] = Blockly.Msg["CONTROLS_REPEAT_INPUT_DO"];
Blockly.Msg["CONTROLS_FOR_INPUT_DO"] = Blockly.Msg["CONTROLS_REPEAT_INPUT_DO"];
Blockly.Msg["CONTROLS_IF_ELSEIF_TITLE_ELSEIF"] = Blockly.Msg["CONTROLS_IF_MSG_ELSEIF"];
Blockly.Msg["CONTROLS_IF_ELSE_TITLE_ELSE"] = Blockly.Msg["CONTROLS_IF_MSG_ELSE"];
Blockly.Msg["CONTROLS_IF_IF_TITLE_IF"] = Blockly.Msg["CONTROLS_IF_MSG_IF"];
Blockly.Msg["CONTROLS_IF_MSG_THEN"] = Blockly.Msg["CONTROLS_REPEAT_INPUT_DO"];
Blockly.Msg["CONTROLS_WHILEUNTIL_INPUT_DO"] = Blockly.Msg["CONTROLS_REPEAT_INPUT_DO"];
Blockly.Msg["LISTS_CREATE_WITH_ITEM_TITLE"] = Blockly.Msg["VARIABLES_DEFAULT_NAME"];
Blockly.Msg["LISTS_GET_INDEX_HELPURL"] = Blockly.Msg["LISTS_INDEX_OF_HELPURL"];
Blockly.Msg["LISTS_GET_INDEX_INPUT_IN_LIST"] = Blockly.Msg["LISTS_INLIST"];
Blockly.Msg["LISTS_GET_SUBLIST_INPUT_IN_LIST"] = Blockly.Msg["LISTS_INLIST"];
Blockly.Msg["LISTS_INDEX_OF_INPUT_IN_LIST"] = Blockly.Msg["LISTS_INLIST"];
Blockly.Msg["LISTS_SET_INDEX_INPUT_IN_LIST"] = Blockly.Msg["LISTS_INLIST"];
Blockly.Msg["MATH_CHANGE_TITLE_ITEM"] = Blockly.Msg["VARIABLES_DEFAULT_NAME"];
Blockly.Msg["PROCEDURES_DEFRETURN_COMMENT"] = Blockly.Msg["PROCEDURES_DEFNORETURN_COMMENT"];
Blockly.Msg["PROCEDURES_DEFRETURN_DO"] = Blockly.Msg["PROCEDURES_DEFNORETURN_DO"];
Blockly.Msg["PROCEDURES_DEFRETURN_PROCEDURE"] = Blockly.Msg["PROCEDURES_DEFNORETURN_PROCEDURE"];
Blockly.Msg["PROCEDURES_DEFRETURN_TITLE"] = Blockly.Msg["PROCEDURES_DEFNORETURN_TITLE"];
Blockly.Msg["TEXT_APPEND_VARIABLE"] = Blockly.Msg["VARIABLES_DEFAULT_NAME"];
Blockly.Msg["TEXT_CREATE_JOIN_ITEM_TITLE_ITEM"] = Blockly.Msg["VARIABLES_DEFAULT_NAME"];

Blockly.Msg["MATH_HUE"] = "230";
Blockly.Msg["LOOPS_HUE"] = "120";
Blockly.Msg["LISTS_HUE"] = "260";
Blockly.Msg["LOGIC_HUE"] = "210";
Blockly.Msg["VARIABLES_HUE"] = "330";
Blockly.Msg["TEXTS_HUE"] = "160";
Blockly.Msg["PROCEDURES_HUE"] = "290";
Blockly.Msg["COLOUR_HUE"] = "20";
Blockly.Msg["VARIABLES_DYNAMIC_HUE"] = "310";
return Blockly.Msg;
}));
